import { useState } from 'react';

export const MiniMainCard = ({ miniCardData }) => {
    const [copiedField, setCopiedField] = useState('');

    const handleCopy = async (value, fieldKey) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopiedField(fieldKey);
            setTimeout(() => setCopiedField(''), 2000); // Clear feedback after 2 seconds
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const CopyIcon = () => (
        <svg 
            width="14" 
            height="14" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="cursor-pointer hover:fill-blue-500 transition-colors duration-200"
        >
            <path 
                d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" 
                fill="currentColor"
            />
        </svg>
    );

    return (
        <div className='w-full rounded-md flex flex-col gap-2'>
            {miniCardData ? (
                Object.keys(miniCardData).map((key, index) => (
                    <div className='px-1 flex flex-row justify-between items-start gap-2' key={index}>
                        <div className={`font-normal whitespace-nowrap flex items-center gap-2`} key={index} >
                            <span>{miniCardData[key].text}</span>
                            {(miniCardData[key].text === 'Device Asset Id' || 
                              miniCardData[key].text === 'Owner Id' || 
                              miniCardData[key].text === 'Space Asset Id') && (
                                <div className="relative">
                                    <button
                                        onClick={() => handleCopy(miniCardData[key].fullValue || miniCardData[key].value, key)}
                                        className="p-1 hover:bg-gray-200 rounded transition-colors duration-200"
                                        title={`Copy ${miniCardData[key].text}`}
                                    >
                                        <CopyIcon />
                                    </button>
                                    {copiedField === key && (
                                        <div className="absolute -top-8 left-0 bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                                            Copied!
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className={`font-bold text-clip tracking-tight break-all
                            ${miniCardData[key].value === 'False' || miniCardData[key].value === 'Online'
                                ? 'text-alertSuccess' : miniCardData[key].value === true || miniCardData[key].value === 'Offline'
                                    ? ' text-alertError'
                                    : 'text-primaryText'}`}>
                            <span>{miniCardData[key].value}</span>
                        </div>
                    </div>
                )))
                :
                <>
                    <div className=' 2xl:h-36 h-28 flex justify-center items-center'>
                        <h4>No data available</h4>
                    </div>
                </>
            }
        </div >
    );
};

// Skip prop validation by setting propTypes to null
MiniMainCard.propTypes = null;

export default MiniMainCard;
